import { useEffect, useRef, useState } from 'react';

export const MobileRotationJoystick = ({ isActive, onRotate }) => {
  const [isDragging, setIsDragging] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const baseRef = useRef(null);
  const touchIdRef = useRef(null);

  const baseRadius = 50;
  const handleRadius = 20;
  const maxDistance = baseRadius - handleRadius;

  useEffect(() => {
    if (!isActive) {
      setPosition({ x: 0, y: 0 });
      setIsDragging(false);
      touchIdRef.current = null;
    }
  }, [isActive]);

  const updatePosition = (touch) => {
    if (!baseRef.current) return;
    const rect = baseRef.current.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    const deltaX = touch.clientX - centerX;
    const deltaY = touch.clientY - centerY;
    const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);

    let finalX = deltaX;
    let finalY = deltaY;

    if (distance > maxDistance) {
      const angle = Math.atan2(deltaY, deltaX);
      finalX = Math.cos(angle) * maxDistance;
      finalY = Math.sin(angle) * maxDistance;
    }

    setPosition({ x: finalX, y: finalY });
    onRotate(finalX / maxDistance, finalY / maxDistance);
  };

  const handleTouchStart = (e) => {
    if (!isActive) return;
    e.preventDefault();
    const touch = e.touches[0];
    touchIdRef.current = touch.identifier;
    setIsDragging(true);
    updatePosition(touch);
  };

  const handleTouchMove = (e) => {
    if (!isDragging || touchIdRef.current === null) return;
    e.preventDefault();
    const touch = Array.from(e.touches).find(t => t.identifier === touchIdRef.current);
    if (touch) updatePosition(touch);
  };

  const handleTouchEnd = (e) => {
    const endedTouch = Array.from(e.changedTouches).find(
      t => t.identifier === touchIdRef.current
    );
    if (endedTouch) {
      setIsDragging(false);
      setPosition({ x: 0, y: 0 });
      touchIdRef.current = null;
      onRotate(0, 0);
    }
  };

  if (!('ontouchstart' in window) || !isActive) return null;

  return (
    <div
      ref={baseRef}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        width: `${baseRadius * 2}px`,
        height: `${baseRadius * 2}px`,
        borderRadius: '50%',
        backgroundColor: 'rgba(247, 147, 26, 0.2)',
        border: '2px solid rgba(247, 147, 26, 0.4)',
        touchAction: 'none',
        userSelect: 'none',
        zIndex: 1000,
        transition: 'opacity 0.2s',
        opacity: isDragging ? 0.8 : 0.6,
      }}
    >
      <div
        style={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          width: `${handleRadius * 2}px`,
          height: `${handleRadius * 2}px`,
          borderRadius: '50%',
          backgroundColor: 'rgba(247, 147, 26, 0.8)',
          border: '2px solid rgba(247, 147, 26, 1)',
          transform: `translate(calc(-50% + ${position.x}px), calc(-50% + ${position.y}px))`,
          transition: isDragging ? 'none' : 'transform 0.2s',
        }}
      />
    </div>
  );
};
